interface LogoProps {
  className?: string
  showText?: boolean
}

export function Logo({ className = '', showText = true }: LogoProps): React.ReactElement {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <span className="relative inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gold-gradient shadow-gold">
        <svg viewBox="0 0 24 24" className="h-6 w-6 text-charcoal-950" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 21h18" />
          <path d="M5 21V9l7-5 7 5v12" />
          <path d="M9 21v-6h6v6" />
        </svg>
      </span>
      {showText && (
        <span className="flex flex-col leading-tight">
          <span className="font-heading text-base font-extrabold text-white sm:text-lg">
            أبو صالح النييفي
          </span>
          <span className="text-[11px] font-semibold tracking-wide text-gold-400">
            للمقاولات
          </span>
        </span>
      )}
    </div>
  )
}
